// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"b1bc93a8d6b9ec5daa36","180":"16d9d08bf03cd9f81d0c","473":"467371c8c334a27862ab"}[chunkId] + ".css";
};